import React,{useEffect,useState} from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {useHistory} from 'react-router-dom'

import { NavLink } from "react-router-dom";
import {
  RiDashboardLine,
  RiFileList3Line,
  RiSettings4Line,
  RiWallet3Line,
  RiQuestionLine,
} from "react-icons/ri";
import {BiLogOut} from "react-icons/bi"
import { TiArrowSync } from "react-icons/ti";
import DashboardNavbarMobile from "./DashboardNavbarMobile";
import DashboardNavbar from "./DashboardNavbar";
import styles from "./Sidebar.module.css";
import DashboardHome from './DashboardHome'
import {AiFillCaretDown} from 'react-icons/ai';

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#f78500"
  },
  menuButton: {
    marginLeft: theme.spacing(30),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: "#fafafa"
  },
}));

function Sidebar(props) {

  const [avatar,setAvatar] = useState("")
  const [name,setName] = useState("")
  const [email,setEmail] = useState("")

  const history = useHistory()

  useEffect(()=>{
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);

      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      setAvatar(item.value.user_data.profile_img)
      setName(`${item.value.user_data.first_name} ${item.value.user_data.last_name}`)
      setEmail(item.value.user_data.email)

      return item.value;
    }

    getWithExpiry("userData");
  },[])

  

  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const logout = () => {
    localStorage.removeItem("userData");
    history.push("/login");
  }


  const data = [
      {name: "Dashboard", link: "/dashboard/home", icon: <RiDashboardLine size={36} />},
      {name: "My Applications", link: "/dashboard/my-applications", icon: <RiFileList3Line size={36} />},
      {name: "Transactions", link: "/dashboard/transactions", icon: <RiWallet3Line size={36} />},
      {name: "Plan a trip", link: "/dashboard/plan-a-trip", icon: <TiArrowSync size={36} />},
      {name: "FAQ", link: "/dashboard/faq", icon: <RiQuestionLine size={36} />},
      {name: "Settings", link: "/dashboard/settings", icon: <RiSettings4Line size={36} />},

  ]

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <div style={{ marginTop: "50px" }}>
        <List className={styles.sidebar}>
        <NavLink to="/dashboard/settings"  strict>
          <div className={styles.listItemName}>
            <img src={avatar} alt="Avatar" className={styles.avatar} />
            <div className={styles.cont}>
            <h6 className={styles.name}>Hi, <b>{name}</b></h6>
            <h6 className={styles.email}>{email}</h6>
            </div>
            <AiFillCaretDown size={18} color="#D3D6E4" />
          </div>
          </NavLink>
          {data.map((value, index)=>(
              <ListItem className={styles.listItemCont} key={index}>
              <NavLink
              // exact
              strict to="/dashboard/"
              to={value.link}
              activeStyle={{
                color: "#5BCFC5",
                backgroundColor: "#EBF8F6",
                fontWeight: "bold",
              }}
              className={styles.listItem}
            >
                <div className={styles.icon}>
                  {value.icon}
                </div>
                <div className={styles.text}>
                  <span>{value.name}</span>
                </div>
            </NavLink>
            </ListItem>
          ))}
            <ListItem className={styles.listItemCont} onClick={logout} style={{cursor:"pointer"}}>
              <div
              // exact
              // strict to="/dashboard/"
              // to={value.link}
              // activeStyle={{
              //   color: "#5BCFC5",
              //   backgroundColor: "#EBF8F6",
              //   fontWeight: "bold",
              // }}
              className={styles.listItem}
            >
                <div className={styles.icon}>
                  <BiLogOut size={36} />
                </div>
                <div className={styles.text}>
                  <span>Logout</span>
                </div>
            </div>
            </ListItem>

        </List>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar} elevation={0} >
        <DashboardNavbar />
        <DashboardNavbarMobile />
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        {/* <div className={classes.toolbar} /> */}
        {(props.cmp === undefined) ?
        (
         <DashboardHome />
        )
        :
        (
          props.cmp
        )
      }
      </main>
    </div>
  );
}

Sidebar.propTypes = {
  window: PropTypes.func,
};

export default Sidebar;
